var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04592 4.33333C8.9381 4.02742 8.7412 3.76077 8.48056 3.56771C8.21992 3.37464 7.90747 3.26399 7.58341 3.25H5.41675C4.98577 3.25 4.57245 3.4212 4.2677 3.72595C3.96295 4.0307 3.79175 4.44402 3.79175 4.875C3.79175 5.30598 3.96295 5.7193 4.2677 6.02405C4.57245 6.3288 4.98577 6.5 5.41675 6.5H7.58341C8.01439 6.5 8.42772 6.6712 8.73246 6.97595C9.03721 7.2807 9.20841 7.69402 9.20841 8.125C9.20841 8.55598 9.03721 8.9693 8.73246 9.27405C8.42772 9.5788 8.01439 9.75 7.58341 9.75H5.41675C5.09269 9.73601 4.78024 9.62536 4.5196 9.43229C4.25896 9.23923 4.06207 8.97258 3.95425 8.66667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.625V3.25M6.5 9.75V11.375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.d03bcddf73712c8df659f9ba616b8ab2.svg";
export { ForwardRef as ReactComponent };